import { gql } from '@apollo/client';

const ReachandImpactQueryHi = gql
`query MyQuery {
  nodeReachAndImpacts(first: 10, langcode: "hi") {
    nodes {
      title
      reachAndImpact {
        ... on ParagraphReachAndImpact {
          id
          titleOfReachAndImpact
          numberOfReachAndImpact
        }
      }
      bannerImage {
        url
        alt
      }
      body {
        value
      }
      id
      path
    }
  }
}
`;
export default ReachandImpactQueryHi;